// extracted by mini-css-extract-plugin
export default {"faqItem":"styles_faqItem__xlcWi","faqItemHeader":"styles_faqItemHeader__3zfrj","devider":"styles_devider__IiPF9","faqDescription":"styles_faqDescription__jTBX0"};